var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import Button from "antd/lib/button";
import { AutoComplete } from 'antd';
var TagSelect = /** @class */ (function (_super) {
    __extends(TagSelect, _super);
    function TagSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedTags: [],
            options: [],
            showMore: false,
            hasShowMore: false,
            inputValue: ''
        };
        _this.autocompleteInputRef = null;
        _this.handleAddTag = function (tag) {
            if (_this.state.selectedTags.some(function (t) { return t.id === tag.id; })) {
                return;
            }
            if (_this.props.isSingular) {
                _this.setState(function (state) { return ({ selectedTags: [tag] }); }, function () {
                    _this.props.onChange && _this.props.onChange(_this.state.selectedTags);
                });
                return;
            }
            _this.setState(function (state) { return ({ selectedTags: state.selectedTags.concat(tag) }); }, function () {
                _this.props.onChange && _this.props.onChange(_this.state.selectedTags);
            });
        };
        _this.handleAddTagByLabel = function (label) {
            var option = _this.props.question.options.find(function (o) { return o.text === label; });
            if (option) {
                _this.handleAddTag(option);
                _this.setState({ inputValue: '' });
            }
        };
        _this.handleRemoveTag = function (tag) {
            _this.setState(function (state) { return ({
                selectedTags: state.selectedTags.filter(function (_) { return _.id !== tag.id; })
            }); }, function () {
                _this.props.onChange && _this.props.onChange(_this.state.selectedTags);
            });
        };
        _this.handleShowMore = function () {
            var showMore = !_this.state.showMore;
            if (showMore) {
                _this.setState({
                    showMore: showMore,
                    options: _this.props.question.options.filter(function (q) { return !q.autocompleteOnly; })
                });
                return;
            }
            _this.setState({
                showMore: showMore,
                options: _this.props.question.options
                    .filter(function (q) { return !q.autocompleteOnly; })
                    .splice(0, 10)
            });
        };
        _this.handleSearch = function (_a) {
            var value = _a.target.value;
            if (_this.props.question.options.some(function (o) { return o.text.toLowerCase().includes(value.toLowerCase()); })) {
                _this.setState({
                    inputValue: value
                });
            }
        };
        _this.handleKeyDown = function (e) {
            if (_this.autocompleteInputRef) {
                if (e.keyCode === 38 || e.keyCode === 40) {
                    e.preventDefault();
                }
                _this.autocompleteInputRef.dispatchEvent(new KeyboardEvent("keydown", __assign({}, e)));
            }
        };
        return _this;
    }
    TagSelect.prototype.componentDidMount = function () {
        var selectedTags = [];
        if (this.props.selectedTabsId) {
            var _loop_1 = function (tabId) {
                var tab = this_1.props.question.options.find(function (o) { return o.id === tabId; });
                if (tab) {
                    selectedTags.push(tab);
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = this.props.selectedTabsId; _i < _a.length; _i++) {
                var tabId = _a[_i];
                _loop_1(tabId);
            }
        }
        this.setState({
            hasShowMore: true,
            options: this.props.question.options
                .filter(function (q) { return !q.autocompleteOnly; })
                .splice(0, 10),
            selectedTags: selectedTags
        });
    };
    TagSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, question = _a.question, intl = _a.intl, isSingular = _a.isSingular;
        var _b = this.state, showMore = _b.showMore, options = _b.options, hasShowMore = _b.hasShowMore, inputValue = _b.inputValue, selectedTags = _b.selectedTags;
        var autoCompleteList = inputValue.trim().length ?
            this.props.question.options
                .filter(function (o) { return o.text.includes(inputValue) && !selectedTags.some(function (t) { return t.id === o.id; }); })
                .map(function (o) { return ({ index: o.text.indexOf(inputValue), option: o }); })
                .sort(function (a, b) { return a.index - b.index; }) :
            [];
        var hideInput = selectedTags.length >= 1 && isSingular;
        return (React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.tagsInput },
                React.createElement("ul", { className: classes.tags }, selectedTags.map(function (tag, index) { return (React.createElement("li", { key: index, className: classes.tag },
                    React.createElement("span", { className: "tag-title" }, tag.text),
                    React.createElement("svg", { onClick: function () { return _this.handleRemoveTag(tag); }, viewBox: "64 64 896 896", focusable: "false", className: "tag-close-icon", "data-icon": "delete", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true" },
                        React.createElement("path", { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" })))); })),
                (options.length !== selectedTags.length && !hideInput) &&
                    React.createElement("input", { onChange: this.handleSearch, value: inputValue, onKeyDown: this.handleKeyDown, disabled: this.props.preventWritingTags, placeholder: question.placeholder })),
            !hideInput &&
                React.createElement(AutoComplete, { dataSource: autoCompleteList.map(function (t) { return t.option.text; }), onSelect: function (value) { return _this.handleAddTagByLabel(value.toString()); }, open: true },
                    React.createElement("input", { ref: function (ref) { return _this.autocompleteInputRef = ref; }, style: { display: 'none' } })),
            React.createElement("div", { className: classes.choicesContainer }, options
                .filter(function (opt) { return !selectedTags.some(function (tag) { return tag.id === opt.id; }); })
                .map(function (opt) { return (React.createElement("div", { key: "" + opt.id, onClick: function () { return _this.handleAddTag(opt); }, className: classes.choice },
                React.createElement("span", null, opt.text))); })),
            hasShowMore && !this.props.disableShowMore && (React.createElement(Button, { className: classes.showMoreBtn, type: "link", onClick: this.handleShowMore }, showMore
                ? intl.formatHTMLMessage({ id: "tagselect.showLess" })
                : intl.formatHTMLMessage({ id: "tagselect.showMore" })))));
    };
    return TagSelect;
}(Component));
export default TagSelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/TagSelect/TagSelect.tsx
// module id = 1486
// module chunks = 0